import { setUpdateDeviceAlertsModal } from '@/slices/modals';
import { useDispatch, useSelector } from '@/store';
import ModalTitle from '@components/modal/ModalTitle';
import StandardAutocompleteIdsWithFallback from '@features/standardDesign/components/autocomplete/StandardAutocompleteIds';
import { Trans, msg } from '@lingui/macro';
import { Box, Dialog, DialogContent, Divider, Skeleton, TextField } from '@mui/material';
import { Suspense, useState, type FC } from 'react';
import ModalActions from 'src/components/modal/ModalActions';
import { useGlobalModal } from '@/hooks/useGlobalModal';
import { FormComponent } from '@features/deviceAlertsModal/components/basicConfigurationTab/FormComponent';

const Fallback: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <>
      <ModalTitle onClose={onClose} title={<Skeleton width={250}></Skeleton>} />
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" width="100%">
              <TextField />
            </Skeleton>
          ))}
        </Box>
      </DialogContent>
      <ModalActions onClose={onClose} />
    </>
  );
};

const UpdateDeviceAlertsModal: FC = () => {
  const dispatch = useDispatch();
  const { updateDeviceAlertsModal } = useSelector((state) => state.modals_store);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(
    updateDeviceAlertsModal.deviceId ?? null,
  );

  const onClose = () => {
    dispatch(
      setUpdateDeviceAlertsModal({
        open: false,
      }),
    );
    setSelectedDeviceId(null);
  };

  const { setIsDirty } = useGlobalModal('deviceAlerts', { closeConfirmation: true });

  return (
    <Dialog onClose={onClose} open={updateDeviceAlertsModal.open} maxWidth="sm" fullWidth>
      <ModalTitle onClose={onClose} title={<Trans>Crear configuración de alertas</Trans>} />
      <Divider />
      <Box px={3} mt={3}>
        <StandardAutocompleteIdsWithFallback
          value={selectedDeviceId}
          dataType="devices"
          onChange={(_, value) => setSelectedDeviceId(value)}
          fullWidth
          label="Dispositivo"
        />
      </Box>
      {selectedDeviceId !== null ? (
        <Suspense fallback={<Fallback onClose={onClose} />}>
          <FormComponent deviceId={selectedDeviceId} onClose={onClose} setIsDirty={setIsDirty} />
        </Suspense>
      ) : (
        <Box pt={4}>
          <Divider />
          <ModalActions onClose={onClose} />
        </Box>
      )}
    </Dialog>
  );
};

export default UpdateDeviceAlertsModal;
